import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b45cce90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "__allAlerts" }
const _hoisted_5 = { class: "alert-card" }
const _hoisted_6 = { class: "truncate-text" }
const _hoisted_7 = { class: "truncate-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Punto de monitorización:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fecha de creación", -1))
const _hoisted_10 = { class: "truncate-text2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Tipo de notificación", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "alert alert-group laptop" }
const _hoisted_15 = ["title"]
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-bell fas" }, null, -1))
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Anterior")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Siguiente")
const _hoisted_21 = { class: "d-flex justify-content-center p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_NoDataComponent = _resolveComponent("NoDataComponent")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_alert_form_component = _resolveComponent("alert-form-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_observer_component = _resolveComponent("observer-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, { class: "header" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("text.alerts")), 1)
        ])
      ]),
      _: 1
    }),
    (_ctx.alerts.length === 0)
      ? (_openBlock(), _createBlock(_component_NoDataComponent, {
          key: 0,
          message: 'No hay alertas configuradas todavía',
          subMessage: '¡Crea las alertas que necesites para empezar a recibir avisos sobre las estimaciones de tus puntos de monitorización!'
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id,
                class: "common-layout"
              }, [
                _createVNode(_component_el_card, {
                  id: item.id,
                  class: _normalizeClass(item.active ? 'active' : 'inactive')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_col, { span: 14 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tooltip, {
                            content: `Nombre de la alerta: ${item.name}`,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", _hoisted_6, [
                                _createElementVNode("b", null, _toDisplayString(item.name), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["content"]),
                          _createVNode(_component_el_tooltip, {
                            content: `Punto de monitorización: ${ _ctx.samplingPointNames[item.id!] ?? '' }`,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_7, [
                                _hoisted_8,
                                _createTextVNode(" " + _toDisplayString(_ctx.samplingPointNames[item.id!] ?? ''), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["content"]),
                          _createElementVNode("p", null, [
                            _hoisted_9,
                            _createTextVNode(": " + _toDisplayString(_ctx.$d(new Date(item.dateTime?.toLocaleString() ?? ""), "dateTimeNoSecs")), 1)
                          ]),
                          _createElementVNode("p", _hoisted_10, [
                            _hoisted_11,
                            _hoisted_12,
                            _createElementVNode("span", {
                              depurify: "",
                              innerHTML: _ctx.getNotificationMethods(item)
                            }, null, 8, _hoisted_13)
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { class: "grid-content" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_el_row, {
                              span: 14,
                              gutter: 8
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "default",
                                      class: "btn-group",
                                      onClick: ($event: any) => (_ctx.deleteAlert(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("em", {
                                          class: "el-icon el-icon-trash fas",
                                          title: _ctx.$t('btn.delete')
                                        }, null, 8, _hoisted_15)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "default",
                                      class: "btn-group",
                                      onClick: ($event: any) => (_ctx.openEntityFormDialog(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("em", {
                                          class: "el-icon el-icon-edit fas",
                                          title: _ctx.$t('btn.edit')
                                        }, null, 8, _hoisted_16)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "default",
                                      class: "btn-group",
                                      onClick: ($event: any) => (_ctx.goToAlerts(item.id?.toString()))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_17
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_switch, {
                                      "model-value": item.active,
                                      class: "switch",
                                      onChange: (newValue) => _ctx.deactivateAlert(item, newValue)
                                    }, null, 8, ["model-value", "onChange"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["id", "class"])
              ]))
            }), 128))
          ]),
          _createVNode(_component_el_dialog, {
            modelValue: _ctx.showAlertForm,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAlertForm) = $event)),
            title: _ctx.$t(_ctx.alertSelected?.id ? 'label.alertEdit' : 'label.alertNew'),
            width: "55%",
            "destroy-on-close": "",
            "custom-class": "app-form"
          }, {
            footer: _withCtx(() => [
              _createElementVNode("span", _hoisted_18, [
                _createVNode(_component_el_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeAlertDialog()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
                  ]),
                  _: 1
                }),
                (_ctx.currentView >= 2)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToPreviousView()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_19
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.currentView <= 2)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToNextView()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.currentView === 3)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveAlert(_ctx.alertSelected)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_alert_form_component, {
                ref: "alertForm",
                id: Number(_ctx.alertSelected?.id),
                currentView: Number(_ctx.currentView)
              }, null, 8, ["id", "currentView"])
            ]),
            _: 1
          }, 8, ["modelValue", "title"])
        ])),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_observer_component, { onIntersect: _ctx.handleScroll }, null, 8, ["onIntersect"])
    ])
  ], 64))
}